import React, { FC, useEffect, useState } from 'react'
import { createUseStyles } from 'react-jss'
import { useNavigate } from 'react-router-dom'
import { DialogClose } from '@radix-ui/react-dialog'
import { AddContact } from '../../../assets/icons'
import { baseButton } from '../../../theme/reuseables'
import { L, L_HTML } from '../../providers/Lokalise'
import { Button } from '../../ui/Button/Button'
import { Circle } from '../../ui/Card'
import { CircleIcon } from '../../ui/Circle/Circle'
import Checkbox from '../../ui/FormElememts/Checkbox'
import { Typography } from '../../ui/Typography/Typography'
import { Dialog } from '../../ui/Dialog/Dialog'
import { colors } from '../../../theme/palette'

const useStyles = createUseStyles({
    button: {
        ...baseButton,
        ...{
            margin: 0,
            padding: '0.5rem',
            cursor: 'pointer',
        },
    },
    modalButtons: {
        display: 'flex',
    },
    modalCheckbox: {
        display: 'flex',
        position: 'absolute',
        right: '20px',
        top: '20px',
    },
})

const GotoMembrsearchModal: FC = () => {
    const [showAgain, setShowAgain] = useState(true)
    const [hideMemberDialog, setHideMemberDialog] = useState(false)
    const classes = useStyles()
    const navigate = useNavigate()

    useEffect(() => {
        const localData = localStorage.getItem('dialog1_show')

        if (localData) {
            const parsed = JSON.parse(localData)

            if (parsed === false) {
                setHideMemberDialog(true)
            }
        }
    }, [])

    if (hideMemberDialog) {
        return (
            <button
                type="button"
                className={classes.button}
                onClick={() => navigate('/alle-foas-medlemmer')}
            >
                <Circle marginRight=".5rem">
                    <CircleIcon
                        backgroundColor={colors.white}
                        borderColor={colors.gray700}
                        borderWidth="1px"
                    >
                        <AddContact />
                    </CircleIcon>
                </Circle>
                <Typography tag="h3" size="M" spacing=".2rem">
                    {L('MINEMEDLEMMER_TILFØJKOLLEGA_KNAP')}
                </Typography>
            </button>
        )
    }

    return (
        <Dialog
            trigger={
                <button type="button" className={classes.button}>
                    <Circle marginRight=".5rem">
                        <CircleIcon
                            backgroundColor={colors.white}
                            borderColor={colors.gray700}
                            borderWidth="1px"
                        >
                            <AddContact />
                        </CircleIcon>
                    </Circle>
                    <Typography tag="h3" size="M" spacing=".2rem">
                        {L('MINEMEDLEMMER_TILFØJKOLLEGA_KNAP')}
                    </Typography>
                </button>
            }
            hideClose
            icon={<AddContact width="46px" />}
        >
            <div className={classes.modalCheckbox}>
                <Checkbox
                    label="Vis ikke igen"
                    isChecked={!showAgain}
                    reversed
                    onChange={() => setShowAgain(!showAgain)}
                />
            </div>
            <Typography
                style={{ marginBottom: '30px' }}
                size="L"
                align="center"
            >
                {L_HTML('TILFØJ-KOLLEGA_POPUP_OVERSKRIFT')}
            </Typography>
            <Typography
                tag="p"
                size="XS"
                align="center"
                style={{ marginBottom: '40px' }}
            >
                {L_HTML('TILFØJ-KOLLEGA-POPUP-TEXT')}
            </Typography>
            <div className={classes.modalButtons}>
                <DialogClose asChild>
                    <Button
                        type="secondary"
                        size="xlarge"
                        onClick={() => {
                            if (!showAgain) {
                                localStorage.setItem(
                                    'dialog1_show',
                                    JSON.stringify(false)
                                )
                            }
                        }}
                    >
                        {L_HTML('TILFØJ-KOLLEGA-POPUP-ANNULER_KNAP')}
                    </Button>
                </DialogClose>

                <Button
                    size="xlarge"
                    onClick={() => {
                        if (!showAgain) {
                            localStorage.setItem(
                                'dialog1_show',
                                JSON.stringify(false)
                            )
                        }
                        navigate('/alle-foas-medlemmer')
                    }}
                >
                    {L_HTML('TILFØJ-KOLLEGA-POPUP-SØG_KNAP')}
                </Button>
            </div>
        </Dialog>
    )
}

export { GotoMembrsearchModal }
